import { Component, OnInit, OnDestroy } from '@angular/core';
import { BlockUI, NgBlockUI } from 'ng-block-ui';
import { AccountService } from '../../services/account.service';
import { GetEmailPreferencesDto, UpdateEmailPreferencesDto } from '../../models/account/account.models';
import { Helpers } from '../../helpers';

@Component({
    selector: 'communication-preferences',
    template: require('./communication.preferences.component.html'),
    styles: [require('./personal.account.shared.css')]
})
export class CommunicationPreferencesComponent implements OnInit, OnDestroy {
    preferences: GetEmailPreferencesDto;
    originalPreferences: GetEmailPreferencesDto;
    feedback: string;

    @BlockUI('email-prefs-block') private emailPrefsBlock: NgBlockUI;

    constructor(private readonly accountService: AccountService, private helpers: Helpers) {
        this.preferences = new GetEmailPreferencesDto();
        
        $('#email-feedback-modal').modal();
        $('#email-feedback-modal').modal('hide');
    }

    ngOnInit() {
        document.body.classList.add('personal-account-fit');
        this.emailPrefsBlock.start();
        this.accountService.getEmailPreferences().subscribe((result: GetEmailPreferencesDto) => {
            this.preferences = result;
            this.originalPreferences = this.helpers.clone(result);
            this.emailPrefsBlock.stop();
        });
    }

    ngOnDestroy() {
        $('#email-feedback-modal').modal('hide');
        document.body.classList.remove('personal-account-fit');
    }

    updatePreferences() {
        if ((!this.preferences.hvcaAlerts && this.originalPreferences.hvcaAlerts) ||
            (!this.preferences.hvtAlerts && this.originalPreferences.hvtAlerts) ||
            (!this.preferences.lvcaAlerts && this.originalPreferences.lvcaAlerts) ||
            (!this.preferences.lvtAlerts && this.originalPreferences.lvtAlerts) ||
            (!this.preferences.pvtAlerts && this.originalPreferences.pvtAlerts) ||
            (!this.preferences.extraAlerts && this.originalPreferences.extraAlerts) ||
            (!this.preferences.newsletters && this.originalPreferences.newsletters) ||
            (!this.preferences.sixMonthsAlerts && this.originalPreferences.sixMonthsAlerts)) {
            $('#email-feedback-modal').modal();
        } else {
            this.submitPreferences();
        }
    }

    clearFeedbackAndUpdatePreferences() {
        this.feedback = null;
        this.submitPreferences();
    }

    submitPreferences() {
        this.emailPrefsBlock.start();
        this.accountService.updateEmailPreferences(new UpdateEmailPreferencesDto(this.preferences, this.feedback))
            .subscribe(() => {
                this.originalPreferences = this.helpers.clone(this.preferences);
                this.feedback = null;
                    $('#email-feedback-modal').modal('hide');
                    this.emailPrefsBlock.stop();
                },
                () => { this.emailPrefsBlock.stop(); });
    }

    toggleCheckboxes() {
        const newValue = !this.preferences.newsletters; // Get the inverse of the current state of one checkbox
        this.preferences.newsletters = newValue;
        this.preferences.hvtAlerts = newValue;
        this.preferences.lvtAlerts = newValue;
        this.preferences.pvtAlerts = newValue;
        this.preferences.hvcaAlerts = newValue;
        this.preferences.lvcaAlerts = newValue;
        this.preferences.sixMonthsAlerts = newValue;
        this.preferences.extraAlerts = newValue;
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/views/account.management/communication.preferences.component.ts